<template>
  <v-row no-gutters>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          <span v-if="model.selected_destination === 'fwd'">Create Forward to Email Forwarder</span>
          <span v-else>Create Discard Email Forwarder</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-on="on" color="primary" class="ml-2">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="model.selected_destination = 'fwd'">
                <v-list-item-title>Forward to Email</v-list-item-title>
              </v-list-item>
              <v-list-item @click="model.selected_destination = 'fail'">
                <v-list-item-title>Discard Email</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </gg-card-header>
        <gg-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="6" class="pb-0">
                  <gg-text-field
                    class="forw"
                    label="Address to forward"
                    v-model="model.address"
                    placeholder="For example: info"
                    name="address"
                    outlined
                    v-validate="rules.address"
                    data-vv-as="Address"
                    :error-messages="errors.collect('address')"
                  >
                    <template v-slot:append>
                      <div class="append-bg">
                        <domain-select no-label
                                       hide-details
                                       solo
                                       flat
                                       v-model="model.domain"
                                       prepend-inner-icon="mdi-at"
                                       style="margin-top: 10px"
                        />
                      </div>
                    </template>
                  </gg-text-field>
                </v-col>
                <v-col cols="12" md="6" v-if="!isBlackholeActive" class="pb-0">
                  <gg-text-field
                    label="Destination"
                    placeholder="Please enter your email"
                    outlined
                    key="destination-input"
                    v-if="isFwdActive"
                    v-model="model.type.forward"
                    v-validate="rules.forward"
                    data-vv-name="forward"
                    data-vv-as="Forward message"
                    :error-messages="errors.collect('forward')"
                  />
                  <gg-text-field
                    v-if="isFailActive"
                    key="fail-input"
                    v-model="model.type.fail"
                    label="Failure message (seen by sender)"
                    v-validate="rules.fail"
                    data-vv-name="fail"
                    data-vv-as="Failure message"
                    :error-messages="errors.collect('fail')"
                  />
                  <gg-text-field
                    v-if="isSystemActive"
                    key="system-input"
                    v-model="model.type.system"
                    label="Failure message (seen by sender)"
                    v-validate="rules.system"
                    data-vv-name="system"
                    data-vv-as="Forward to system account"
                    :error-messages="errors.collect('system')"
                  ></gg-text-field>
                  <autocomplete-dir
                    v-if="isPipeActive"
                    key="dir-input"
                    v-model="model.type.pipe"
                    v-validate="rules.pipe"
                    data-vv-name="pipe"
                    data-vv-as="Pipe to a program"
                    :error-messages="errors.collect('pipe')"
                  />
                </v-col>
                <v-col cols="12">
                  <gg-btn color="primary" tile :loading="loading" @click="addNewForwarder">
                    Create
                  </gg-btn>
                </v-col>
              </v-row>
            </v-container>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import DomainSelect from '@/components/Common/DomainSelect'
import AutocompleteDir from '@/components/Common/AutocompleteDir'

export default {
  name: 'AddForwarder',
  components: { DomainSelect, AutocompleteDir },
  data: () => ({
    loading: false,
    additional: false,
    initialModel: {
      address: '',
      domain: '',
      selected_destination: 'fwd',
      type: {
        forward: '',
        fail: 'No such person at this address.',
        system: '',
        pipe: '',
        discard: ''
      },
    },
    model: {
      address: '',
      domain: '',
      selected_destination: 'fwd',
      type: {
        forward: '',
        fail: 'No such person at this address.',
        system: '',
        pipe: '',
        discard: ''
      },
    },
    rules: {
      address: {
        required: true
      },
      forward: {
        required: true,
        email: true
      },
      fail: {
        required: true,
      },
      system: {
        required: true,
      },
      pipe: {
        required: true,
      }
    }
  }),
  computed: {
    isFwdActive () {
      return this.model.selected_destination === 'fwd'
    },
    // Check if "fail" input is checked
    isFailActive () {
      return this.model.selected_destination === 'fail'
    },
    // Check if "system" input is checked
    isSystemActive () {
      return this.model.selected_destination === 'system'
    },
    // Check if "pipe" input is checked
    isPipeActive () {
      return this.model.selected_destination === 'pipe'
    },
    isBlackholeActive () {
      return this.model.selected_destination === 'blackhole'
    },
  },
  watch: {
    'model.domain' (val) {
      this.$emit('set-domain', val)
    }
  },
  methods: {
    ...mapActions({
      addForwarder: 'email/addForwarder',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),

    async addNewForwarder () {
      try {
        const valid = await this.$validator.validateAll()
        if (valid) {
          this.loading = true
          const data = {
            domain: this.model.domain,
            email: `${this.model.address}@${this.model.domain}`,
            fwdopt: this.model.selected_destination,
            fwdemail: this.model.type.forward,
            failmsgs: this.model.type.fail,
            fwdsystem: this.model.type.system,
            pipefwd: this.model.type.pipe,
            _username: this.$route.query.user,
          }

          await this.addForwarder(data)

          this.actionCompleted()
          this.reportSuccess('Forwarder successfully added')
        }
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },

    clearErrors () {
      this.$nextTick()
      this.$validator.reset()
    },

    // Event that fired when data send
    actionCompleted () {
      this.$emit('action-completed')
      this.additional = false
      const domain = this.model.domain
      this.model = Object.assign({}, this.initialModel)
      this.model.domain = domain
    }
  },
}
</script>

<style lang="scss">
.forw {
  overflow: hidden;
//  .v-input__append-inner {
//    margin-top: -5px;
//  }
}
.append-bg {
  position: absolute;
  right: 2px;
  top: 2px;
  background: #ececec;
  height: calc(100% - 4px);
  > div {
    margin-top: 3px !important;
  }
}
</style>
